"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaretTypes = exports.Caret = void 0;
var _react = _interopRequireDefault(require("react"));
var _BaseSvg = require("./BaseSvg");
var _utils = require("../utils");
var _excluded = ["type", "className", "size"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var CaretTypes = ['caret-right-regular-16', 'caret-right-medium-16', 'caret-right-heavy-16', 'caret-left-regular-16', 'caret-left-medium-16', 'caret-left-heavy-16', 'caret-down-regular-16', 'caret-down-medium-16', 'caret-down-heavy-16', 'caret-up-regular-16', 'caret-up-medium-16', 'caret-up-heavy-16', 'caret-filled-down', 'caret-filled-right', 'caret-filled-up', 'caret-filled-left', 'caret-right-normal-24', 'caret-right-heavy-24', 'caret-left-normal-24', 'caret-left-heavy-24', 'caret-down-normal-24', 'caret-down-heavy-24', 'caret-up-normal-24', 'caret-up-heavy-24'];
exports.CaretTypes = CaretTypes;
var Caret = function Caret(_ref) {
  var type = _ref.type,
    className = _ref.className,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  switch (type) {
    case 'caret-right-regular-16':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M11.989 8.098L12 8.005l-.001-.071-.017-.1-.03-.087-.029-.055-.046-.066-.052-.055-6.992-6.44a.482.482 0 00-.711.057.57.57 0 00-.01.691l.063.07 6.547 6.033-6.548 6.07a.567.567 0 00-.05.761c.161.2.43.242.637.112l.074-.057 6.991-6.48.053-.056.03-.042.036-.064.027-.066.017-.062z"
        }));
      }
    case 'caret-right-medium-16':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.256 2.434c-.282-.27-.339-.762-.132-1.11.123-.2.32-.324.527-.324.141 0 .283.056.395.157l6.69 6.217c.17.156.264.38.264.638a.826.826 0 01-.264.627l-6.69 6.195a.52.52 0 01-.48.157c-.178-.023-.329-.135-.442-.314-.207-.347-.15-.851.132-1.11l6.013-5.555-6.013-5.578z"
        }));
      }
    case 'caret-right-heavy-16':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.325 2.853c-.355-.334-.435-.98-.16-1.433.151-.258.41-.42.676-.42.178 0 .365.075.507.215l6.323 5.968c.213.204.329.506.329.83 0 .322-.116.624-.329.818l-6.323 5.956a.726.726 0 01-.623.205.873.873 0 01-.56-.41c-.275-.452-.195-1.098.16-1.443l5.46-5.127-5.46-5.16z"
        }));
      }
    case 'caret-left-regular-16':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M11.19 1.125c.217-.2.531-.156.702.097.171.253.134.62-.083.819l-6.5 5.978 6.498 5.94c.218.198.256.564.085.818-.17.253-.484.298-.701.099l-7-6.397c-.217-.199-.255-.565-.084-.819a.543.543 0 01.105-.116l6.978-6.419z"
        }));
      }
    case 'caret-left-medium-16':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.744 13.566c.282.27.339.762.132 1.11-.123.2-.32.324-.527.324a.598.598 0 01-.396-.157l-6.69-6.217A.851.851 0 014 7.988c0-.246.094-.482.263-.627l6.69-6.195a.52.52 0 01.48-.156c.18.022.33.134.443.313.207.347.15.851-.132 1.11L5.73 7.987l6.013 5.578z"
        }));
      }
    case 'caret-left-heavy-16':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.675 13.147c.355.334.435.98.16 1.433-.151.258-.41.42-.676.42a.734.734 0 01-.507-.215L4.329 8.817A1.141 1.141 0 014 7.987c0-.322.116-.624.329-.818l6.323-5.956a.726.726 0 01.623-.205.873.873 0 01.56.41c.275.452.195 1.098-.16 1.443l-5.46 5.127 5.46 5.16z"
        }));
      }
    case 'caret-down-regular-16':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M1.132 4.835a.482.482 0 01.055-.712.567.567 0 01.761.051l6.07 6.55 6.033-6.549a.567.567 0 01.761-.053c.226.182.252.5.057.711l-6.433 6.985a.534.534 0 01-.185.134.57.57 0 01-.645-.133L1.132 4.835z"
        }));
      }
    case 'caret-down-medium-16':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.566 4.256c.27-.282.762-.339 1.11-.132.2.123.324.32.324.527a.598.598 0 01-.157.395l-6.217 6.69a.851.851 0 01-.638.264.826.826 0 01-.627-.264l-6.195-6.69a.52.52 0 01-.156-.48c.022-.178.134-.329.313-.442.347-.207.851-.15 1.11.132l5.555 6.013 5.578-6.013z"
        }));
      }
    case 'caret-down-heavy-16':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.147 4.325c.334-.355.98-.435 1.433-.16.258.151.42.41.42.676a.734.734 0 01-.215.507l-5.968 6.323a1.141 1.141 0 01-.83.329c-.322 0-.624-.116-.818-.329L1.213 5.348a.726.726 0 01-.205-.623.873.873 0 01.41-.56c.452-.275 1.098-.195 1.443.16l5.127 5.46 5.16-5.46z"
        }));
      }
    case 'caret-up-regular-16':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M14.868 11.165c.195.211.17.53-.055.712a.567.567 0 01-.761-.051l-6.07-6.55-6.033 6.549a.567.567 0 01-.761.053.482.482 0 01-.057-.711l6.433-6.985a.518.518 0 01.185-.134.57.57 0 01.645.133l6.474 6.984z"
        }));
      }
    case 'caret-up-medium-16':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.434 11.744c-.27.282-.762.339-1.11.132-.2-.123-.324-.32-.324-.527 0-.141.056-.283.157-.396l6.217-6.69A.851.851 0 018.012 4c.246 0 .482.094.627.263l6.195 6.69a.52.52 0 01.157.48c-.023.18-.135.33-.314.443-.347.207-.851.15-1.11-.132L8.013 5.73l-5.578 6.013z"
        }));
      }
    case 'caret-up-heavy-16':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.853 11.675c-.334.355-.98.435-1.433.16-.258-.151-.42-.41-.42-.676 0-.178.075-.365.215-.507l5.968-6.323c.204-.213.506-.329.83-.329.322 0 .624.116.818.329l5.956 6.323c.173.178.237.4.205.623a.873.873 0 01-.41.56c-.452.275-1.098.195-1.443-.16l-5.127-5.46-5.16 5.46z"
        }));
      }
    case 'caret-filled-down':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.857 5.889l-6.47 6.942a.516.516 0 01-.384.17.545.545 0 01-.395-.17L1.14 5.889a.537.537 0 01-.095-.572A.538.538 0 011.535 5h12.926a.54.54 0 01.492.317.518.518 0 01-.096.572z"
        }));
      }
    case 'caret-filled-right':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.889 1.142l6.942 6.47c.106.095.17.234.17.384a.545.545 0 01-.17.395l-6.942 6.47a.537.537 0 01-.572.094.538.538 0 01-.317-.49V1.537a.54.54 0 01.317-.492.518.518 0 01.572.096z"
        }));
      }
    case 'caret-filled-up':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.142 12.111l6.47-6.942A.515.515 0 017.996 5c.15 0 .298.063.395.17l6.47 6.941a.537.537 0 01.094.572.537.537 0 01-.49.317H1.537a.54.54 0 01-.492-.317.518.518 0 01.096-.572z"
        }));
      }
    case 'caret-filled-left':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.111 1.142L3.17 7.612A.515.515 0 003 7.996c0 .15.063.298.17.395l6.941 6.47c.16.137.381.18.572.094a.537.537 0 00.317-.49V1.537a.54.54 0 00-.317-.492.518.518 0 00-.572.096z"
        }));
      }
    case 'caret-right-normal-24':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.693 21.988c-.207-.02-.383-.143-.528-.358A1.011 1.011 0 016 21.05c0-.307.124-.603.33-.776l9.508-8.259L6.33 3.735A1.064 1.064 0 016 2.95c0-.214.052-.41.165-.572A.751.751 0 016.807 2a.76.76 0 01.476.173l10.376 9.066a.974.974 0 01.341.775c0 .306-.124.593-.341.766L7.272 21.824a.65.65 0 01-.579.164z"
        }));
      }
    case 'caret-right-heavy-24':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.384 4.048c-.423-.384-.508-1.088-.197-1.584.183-.288.48-.464.79-.464.212 0 .423.08.593.224l10.035 8.881c.254.224.395.544.395.912 0 .352-.141.688-.395.896L7.57 21.763a.804.804 0 01-.72.223c-.268-.032-.494-.192-.663-.448-.311-.496-.226-1.216.197-1.584l9.019-7.937-9.019-7.969z"
        }));
      }
    case 'caret-left-normal-24':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.3069 2.01227C17.5138 2.03268 17.6897 2.15518 17.8345 2.36956C17.9483 2.53289 18 2.73706 18 2.95143C18 3.25768 17.8759 3.55372 17.67 3.72726L8.16203 11.9858L17.67 20.2647C17.8759 20.4485 18 20.7445 18 21.0498C18 21.2641 17.9483 21.4591 17.8345 21.6224C17.6897 21.8664 17.4414 22.0002 17.1931 22.0002C17.0276 22.0002 16.8528 21.9389 16.7173 21.8266L6.34133 12.7606C6.11374 12.5677 5.99995 12.3022 5.99995 11.9858C5.99995 11.6795 6.12409 11.3927 6.34133 11.2202L16.7276 2.1756C16.8828 2.03268 17.0794 1.97143 17.3069 2.01227Z"
        }));
      }
    case 'caret-left-heavy-24':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.616 19.952c.423.384.508 1.088.197 1.584-.183.288-.48.464-.79.464a.922.922 0 01-.593-.224L6.395 12.895A1.188 1.188 0 016 11.983c0-.352.141-.688.395-.896l10.035-8.85a.804.804 0 01.72-.223c.268.032.494.192.663.448.311.496.226 1.216-.197 1.584l-9.019 7.937 9.019 7.969z"
        }));
      }
    case 'caret-down-normal-24':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.012 6.693c.02-.207.143-.383.358-.528.163-.113.367-.165.581-.165.307 0 .603.124.776.33l8.259 9.508 8.279-9.508c.183-.206.48-.33.785-.33.214 0 .41.052.572.165a.751.751 0 01.378.642.76.76 0 01-.173.476L12.76 17.659a.974.974 0 01-.775.341c-.306 0-.593-.124-.766-.341L2.176 7.272a.651.651 0 01-.164-.579z"
        }));
      }
    case 'caret-down-heavy-24':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.952 6.384c.384-.423 1.088-.508 1.584-.197.288.183.464.48.464.79 0 .212-.08.423-.224.593l-8.881 10.035a1.188 1.188 0 01-.912.395c-.352 0-.688-.141-.896-.395L2.237 7.57a.804.804 0 01-.223-.72c.032-.268.192-.494.448-.663.496-.311 1.216-.226 1.584.197l7.937 9.019 7.969-9.019z"
        }));
      }
    case 'caret-up-normal-24':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.988 17.307c-.02.207-.143.383-.358.527a1.011 1.011 0 01-.582.166c-.306 0-.602-.124-.775-.33l-8.259-9.508-8.279 9.508c-.184.206-.48.33-.785.33a.982.982 0 01-.573-.166.751.751 0 01-.377-.64.76.76 0 01.173-.477L11.24 6.341A.974.974 0 0112.014 6c.306 0 .593.124.766.341l9.044 10.387a.651.651 0 01.164.579z"
        }));
      }
    case 'caret-up-heavy-24':
      {
        return /*#__PURE__*/_react.default.createElement(_BaseSvg.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: "fill-current ".concat(className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.048 17.616c-.384.423-1.088.508-1.584.197-.288-.183-.464-.48-.464-.79 0-.212.08-.423.224-.593l8.881-10.035c.224-.254.544-.395.912-.395.352 0 .688.141.896.395l8.85 10.035a.804.804 0 01.223.72c-.032.268-.192.494-.448.663-.496.311-1.216.226-1.584-.197l-7.937-9.019-7.969 9.019z"
        }));
      }
    default:
      {
        throw new Error((0, _utils.getErrorMessage)(type));
      }
  }
};
exports.Caret = Caret;